module.exports = function() {
  return new Worker(__webpack_public_path__ + "6d03fea9700626c62c44.worker.js");
};